// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_kd7","cls2":"CoScientistLandingPage-cls2_KQA CoScientistLandingPage-cls1_kd7"};